// @components
import {
    Card,
    Avatar,
    Typography,
} from "@material-tailwind/react";

import { StyledScrollContainer } from '../../../components/StyledScrollContainer';
import AppImages from "../../../assets/AppImages";

interface Payout {
    img: string;
    title: string;
    value: string;
    hours: string;
}

const TABLE_ROW: Payout[] = [];
//@ts-ignore
const TABLE_ROW_: Payout[] = [
    {
        img: "https://v3.material-tailwind.com/woman-profile-1.jpg",
        title: "Tina Andrew",
        value: "$1,000.00",
        hours: "45hrs",
    }, {
        img: "https://v3.material-tailwind.com/woman-profile-2.jpg",
        title: "Emma Roberts",
        value: "$2,150.00",
        hours: "24hrs",
    }, {
        img: "https://v3.material-tailwind.com/man-profile-1.jpg",
        title: "Nora Hazel",
        value: "$940.00",
        hours: "32hrs",
    }, {
        img: "https://v3.material-tailwind.com/woman-profile-3.jpg",
        title: "Jane Cooper",
        value: "$2,150.00",
        hours: "28hrs",
    }, {
        img: "https://v3.material-tailwind.com/man-profile-2.jpg",
        title: "Wade Warren",
        value: "$250.00",
        hours: "8hrs",
    },
];

export function DashboardPayouts() {
    return (
        <>
            <Card.Header className="w-full m-0 items-start rounded-none flex flex-wrap gap-0 justify-between p-5 border-b border-surface">
                <Typography
                    type="lead"
                    color="default"
                    className="font-semibold mb-1"
                >
                    This Week Payouts
                </Typography>
                <Typography type="small" className="text-foreground block">
                    These are details about all payouts.
                </Typography>
            </Card.Header>
            <StyledScrollContainer className="h-[310px]">
                <Card.Body className="p-0 rounded-none ">
                    <table className="w-full min-w-max table-auto text-left">
                        <tbody>
                            {TABLE_ROW.map(
                                ({
                                    img,
                                    title,
                                    value,
                                    hours,
                                }, key) => (
                                    <tr key={key}>
                                        <td className="p-4 border-b border-surface">
                                            <div className="flex items-center gap-3">
                                                <Avatar src={img} alt={title} />
                                                <div className="space-y-1">
                                                    <Typography
                                                        type="small"
                                                        color="default"
                                                        className="font-semibold block"
                                                    >
                                                        {title}
                                                    </Typography>

                                                    <div className="flex gap-x-1">
                                                        <Typography
                                                            type="small"
                                                            className="block text-green-500"
                                                        >
                                                            {value}
                                                        </Typography>
                                                        <Typography
                                                            type="small"
                                                            className="block text-foreground"
                                                        >
                                                            for
                                                        </Typography>
                                                        <Typography
                                                            type="small"
                                                            className="block text-[#64748B]"
                                                        >
                                                            {hours}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>

                    {TABLE_ROW.length == 0 &&
                        <div className="flex flex-col my-20 gap-5 justify-center items-center h-full">
                            <div className="flex bg-secondary items-center p-4 rounded-full">
                                <AppImages.iconCash className="w-6 h-6" />
                            </div>
                            <Typography className="text-primary font-semibold text-2xl">
                                No upcoming payouts
                            </Typography>
                        </div>
                    }
                </Card.Body>
            </StyledScrollContainer>
        </>
    );
}
